module.exports = __webpack_public_path__ + "assets/minus.23fcdae1.svg";